import {css, unsafeCSS} from "lit";
import {sbkCoreBreakpointMd, sbkCoreBreakpointXl} from "@/tokens/variables";

const breakpointXl = unsafeCSS(`${sbkCoreBreakpointXl}`);
const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);

export const style = css`
    :host {
        --link-border-focus: var(--_link-border-focus, var(--sbkLinkBorderOnLightFocus));
        --link-color: var(--_link-color, var(--sbkLinkFgColorOnLightEnabled));
        --link-color-hover: var(--_link-color-hover, var(--sbkLinkFgColorOnLightHover));
        --link-color-active: var(--_link-color-active, var(--sbkLinkFgColorOnLightActive));
        --link-color-disabled: var(--_link-color-disabled, var(--sbkLinkFgColorOnLightDisabled));
        --link-color-visited: var(--_link-color-visited, var(--sbkLinkFgColorOnLightVisited));
        --link-color-selected: var(--_link-color-selected, var(--sbkLinkFgColorOnLightSelected));
        box-sizing: border-box;
        display: inline-block;
    }

    div.link-wrapper {
        display: flex;
        align-items: center;
        @media all and (max-width: ${breakpointXl}) {
            height: 100%;
        }
    }

    .link {
        display: flex;
        background-color: unset;
        gap: var(--sbkLinkSpacing4xs);
        align-items: center;
        outline: 2px solid transparent;
        outline-offset: var(--sbkLinkBorderGapFocus);
        border-radius: var(--sbkLinkBorderRadiusFocus);
        border: none;
        cursor: pointer;
        text-decoration: none;
        color: var(--link-color);
        fill: currentColor;
        padding: 0;
        font: inherit;

        overflow-wrap: break-word;
        word-wrap: break-word;
        /* This is the dangerous one in WebKit, as it breaks things wherever */
        word-break: break-all;
        /* Instead use this non-standard one: */
        word-break: break-word;
        hyphens: auto;

        &:not(.link--selected):visited {
            color: var(--link-color-visited);
        }

        &:not(.link--selected):active {
            color: var(--link-color-active);

            .link__text {
                text-decoration: underline;
            }
        }

        &:focus-visible {
            outline: var(--link-border-focus);
        }

        @media (hover: hover) and (pointer: fine) {
            &:not(.link--selected):hover {
                @media all and (min-width: ${breakpointMd}) {
                    color: var(--link-color-hover);

                    .link__text {
                        text-decoration: underline;
                    }
                }
            }
        }
    }

    .link--selected {
        color: var(--link-color-selected);
    }

    .link--disabled {
        color: var(--link-color-disabled);
        cursor: not-allowed;
        margin: 0;
        padding: 0;
        display: inline-block;
        outline: 2px solid transparent;
        outline-offset: var(--sbkLinkBorderGapFocus);
        border-radius: var(--sbkLinkBorderRadiusFocus);
        border: none;
        text-decoration: none;
        fill: currentColor;
    }

    .link-regular-bold {
        font-weight: 700;
    }

    .link-regular-2xs {
        font: var(--sbkLinkRegular2xs);
    }

    .link-regular-xs {
        font: var(--sbkLinkRegularXs);
    }

    .link-regular-sm {
        font: var(--sbkLinkRegularSm);
    }

    .link-regular-md {
        font: var(--sbkLinkRegularMd);
    }

    .link-icon-navigation-bold {
        font-weight: 700;

        .link__text {
            display: none;
            @media all and (max-width: ${breakpointXl}) {
                display: block;
            }
        }

        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }
    }

    .link-icon-navigation-2xs {
        font: var(--sbkLinkRegular2xs);
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }

        .link__text {
            display: none;
            @media all and (max-width: ${breakpointXl}) {
                display: block;
            }
        }
    }

    .link-icon-navigation-xs {
        font: var(--sbkLinkRegularXs);
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }

        .link__text {
            display: none;
            @media all and (max-width: ${breakpointXl}) {
                display: block;
            }
        }
    }

    .link-icon-navigation-sm {
        font: var(--sbkLinkRegularSm);
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }

        .link__text {
            display: none;
            @media all and (max-width: ${breakpointXl}) {
                display: block;
            }
        }
    }

    .link-icon-navigation-md {
        font: var(--sbkLinkRegularMd);
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }

        .link__text {
            display: none;
            @media all and (max-width: ${breakpointXl}) {
                display: block;
            }
        }
    }

    .link-icon-navigation-bold-2xs {
        font: var(--sbkLinkBold2xs);
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }

        .link__text {
            display: none;
            @media all and (max-width: ${breakpointXl}) {
                display: block;
            }
        }
    }

    .link-icon-navigation-bold-xs {
        font: var(--sbkLinkBoldXs);
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }

        .link__text {
            display: none;
            @media all and (max-width: ${breakpointXl}) {
                display: block;
            }
        }
    }

    .link-icon-navigation-bold-sm {
        font: var(--sbkLinkBoldSm);
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }

        .link__text {
            display: none;
            @media all and (max-width: ${breakpointXl}) {
                display: block;
            }
        }
    }

    .link-icon-navigation-bold-md {
        font: var(--sbkLinkBoldMd);
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }

        .link__text {
            display: none;
            @media all and (max-width: ${breakpointXl}) {
                display: block;
            }
        }
    }

    .link-reduced-navigation-bold {
        font-weight: 700;
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }
    }

    .link-reduced-navigation-2xs {
        font: var(--sbkLinkRegular2xs);
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }
    }

    .link-reduced-navigation-xs {
        font: var(--sbkLinkRegularXs);
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }
    }

    .link-reduced-navigation-sm {
        font: var(--sbkLinkRegularSm);
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }
    }

    .link-reduced-navigation-md {
        font: var(--sbkLinkRegularMd);
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }
    }

    .link-reduced-navigation-bold-2xs {
        font: var(--sbkLinkBold2xs);
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }
    }

    .link-reduced-navigation-bold-xs {
        font: var(--sbkLinkBoldXs);
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }
    }

    .link-reduced-navigation-bold-sm {
        font: var(--sbkLinkBoldSm);
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }
    }

    .link-reduced-navigation-bold-md {
        font: var(--sbkLinkBoldMd);
        @media all and (max-width: ${breakpointXl}) {
            flex-direction: column;
        }
    }

    .link-navigation {
        justify-content: space-between;
        line-height: var(--sbkCoreLineHightDefaultLg);
    }

    .link-navigation-bold {
        font-weight: 700;
        justify-content: space-between;
        line-height: var(--sbkCoreLineHightDefaultLg);
    }

    .link-navigation-2xs {
        font: var(--sbkLinkRegular2xs);
        justify-content: space-between;
        line-height: var(--sbkCoreLineHightDefaultLg);
    }

    .link-navigation-xs {
        font: var(--sbkLinkRegularXs);
        justify-content: space-between;
        line-height: var(--sbkCoreLineHightDefaultLg);
    }

    .link-navigation-sm {
        font: var(--sbkLinkRegularSm);
        justify-content: space-between;
        line-height: var(--sbkCoreLineHightDefaultLg);
    }

    .link-navigation-md {
        font: var(--sbkLinkRegularMd);
        justify-content: space-between;
        line-height: var(--sbkCoreLineHightDefaultLg);
    }

    .link-underlined {
        .link__text {
            text-decoration: underline;
        }
    }

    .link-underlined-bold {
        text-decoration: underline;
        font-weight: 700;
    }

    .link-underlined-2xs {
        font: var(--sbkLinkUnderlined2xs);

        .link__text {
            text-decoration: underline;
        }
    }

    .link-underlined-xs {
        font: var(--sbkLinkUnderlinedXs);

        .link__text {
            text-decoration: underline;
        }
    }

    .link-underlined-sm {
        font: var(--sbkLinkUnderlinedSm);

        .link__text {
            text-decoration: underline;
        }
    }

    .link-underlined-md {
        font: var(--sbkLinkUnderlinedMd);

        .link__text {
            text-decoration: underline;
        }
    }

    .link-regular-bold-2xs {
        font: var(--sbkLinkBold2xs);
    }

    .link-regular-bold-xs {
        font: var(--sbkLinkBoldXs);
    }

    .link-regular-bold-sm {
        font: var(--sbkLinkBoldSm);
    }

    .link-regular-bold-md {
        font: var(--sbkLinkBoldMd);
    }

    .link-underlined-bold-xs {
        font: var(--sbkLinkBoldUnderlinedXs);

        .link__text {
            text-decoration: underline;
        }
    }

    .link-underlined-bold-sm {
        font: var(--sbkLinkBoldUnderlinedSm);

        .link__text {
            text-decoration: underline;
        }
    }

    .link-underlined-bold-md {
        font: var(--sbkLinkBoldUnderlinedMd);

        .link__text {
            text-decoration: underline;
        }
    }

    .link.link--noHyphens {
        hyphens: none;
        word-break: keep-all;
    }
`;
